import script from "./second.vue?vue&type=script&setup=true&lang=ts"
export * from "./second.vue?vue&type=script&setup=true&lang=ts"

import "./second.vue?vue&type=style&index=0&id=055db1d4&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-055db1d4"]])

export default __exports__